import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Header from "../../components/layout/Header";
import Loader from "../../components/layout/Loader";
import Sidebar from "../../components/layout/Sidebar";
import { listOrderAction } from "../../redux/actions/OrderAction";
import { getProductTypesAction } from "../../redux/actions/ProductTypeactions";
import { ListDealerAction } from "../../redux/actions/DealerAction";
import { Card, CardContent, Box } from "@mui/material";
import moment from "moment-timezone";
import OrderFilter from "../../components/order/Orderlist/OrderFilter";
import OrderTabsAndList from "../../components/order/Orderlist/OrderTabsAndList";

const ListOrder = ({ nav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [filter, setFilter] = useState("All");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("dealerName");
  const [tabValue, setTabValue] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [productTypeFilter, setProductTypeFilter] = useState("");
  const [dealerFilter, setDealerFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;
  const orderList = useSelector((state) => state.orderList);
  const { loading, orders } = orderList;
  const productTypesList = useSelector((state) => state.productTypes);
  const { loading: ptLoading, error: ptError, productTypes } = productTypesList;
  const listDealer = useSelector((state) => state.listDealer);
  const { loading: dealerLoading, success, dealer } = listDealer;

  const totalOrders = orders?.totalOrders;
  const timezone = orders?.timezone || "UTC";

  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
      return;
    }
    window.scrollTo(0, 0);
    dispatch(getProductTypesAction(userInfo.token));
    dispatch(ListDealerAction(userInfo.token));
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    const statuses = [
      "All",
      "ready_to_process",
      "processing",
      "processed",
      "delivered",
    ];
    const filters = {
      status: statuses[tabValue],
      page,
      limit,
      orderBy,
      order,
      search,
      productType: productTypeFilter,
      dealerId: dealerFilter,
      startDate: startDate ? moment(startDate).tz(timezone).startOf("day").toISOString() : null,
      endDate: endDate ? moment(endDate).tz(timezone).endOf("day").toISOString() : null,
    };
    dispatch(listOrderAction(filters, userInfo.token));
    setRefresh(false);
  }, [
    dispatch,
    tabValue,
    page,
    limit,
    orderBy,
    order,
    refresh,
    userInfo.token,
    search,
    productTypeFilter,
    dealerFilter,
    startDate,
    endDate,
  ]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const clearAllFilters = () => {
    setSearch("");
    setProductTypeFilter("");
    setDealerFilter("");
    setStartDate("");
    setEndDate("");
    setPage(1);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const formatDate = (dateString) => {
    return moment(dateString).tz(timezone).format("DD-MM-YYYY");
  };

  return (
    <div className={nav.isSidebar}>
      <Header nav={nav} />
      <Sidebar nav={nav} />
      <main className="page-content">
        <Card
          sx={{
            background: "linear-gradient(135deg, #1a3857ff 0%, #193450ff 100%)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            borderRadius: 3,
            overflow: "visible",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <OrderFilter
              search={search}
              handleSearchChange={handleSearchChange}
              productTypeFilter={productTypeFilter}
              setProductTypeFilter={setProductTypeFilter}
              dealerFilter={dealerFilter}
              setDealerFilter={setDealerFilter}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              clearAllFilters={clearAllFilters}
              hasActiveFilters={search || productTypeFilter || dealerFilter || startDate || endDate}
              productTypes={productTypes}
              dealer={dealer}
              totalOrders={totalOrders}
              setPage={setPage}
              setRefresh={setRefresh}
            />
            <OrderTabsAndList
              tabValue={tabValue}
              handleTabChange={handleTabChange}
              orders={orders}
              loading={loading}
              ptLoading={ptLoading}
              dealerLoading={dealerLoading}
              order={order}
              orderBy={orderBy}
              handleRequestSort={handleRequestSort}
              formatDate={formatDate}
              setRefresh={setRefresh}
              totalOrders={totalOrders}
              page={page}
              handleChangePage={handleChangePage}
              limit={limit}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default ListOrder;